<span class="mui-btn__spinner"
      role="progressbar"
      data-testid="mui-btn-spinner"
      [attr.aria-describedby]="id"
      [attr.aria-hidden]="!working ? 'true' : null"
      [ngClass]="{ 'mui-btn__spinner--active': working }"></span>
<i *ngIf="icon" mui-icon font="fa" [name]="icon" class="mui-btn__icon" data-testid="mui-btn-icon"></i>
<span class="mui-btn__content">
  <ng-content></ng-content>
</span>
